import CTAButton from '~/shared/components/cta-button/cta-button';
import { LIMIT_OF_CHARACTERS } from '~/shared/constants';
import { validate, validator } from '~/shared/helpers/validation-helpers';

const getFreeConsultationFormConfig = ({ t }: { t: (key: string, options: { ns: string[] }) => string }) => {
  const validation = validator({ t });

  return {
    name: 'freeConsultation',
    pattern: 'basicFormPattern',
    textAlign: 'center',
    initialValues: {
      userName: '',
      phone: '',
    },
    position4: {
      formFields: [
        {
          name: 'userName',
          label: t('field.your-name.title'),
          placeholder: t('field.your-name.placeholder'),
          validate: validate([
            validation.required,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.USER_NAME.MIN,
              max: LIMIT_OF_CHARACTERS.USER_NAME.MAX,
            }),
          ]),
          type: 'text',
        },
        {
          name: 'phone',
          label: t('field.your-phone-number.title'),
          placeholder: t('field.your-phone-number.placeholder'),
          validate: validate([
            validation.required,
            validation.phoneValid,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.PHONE_NUMBER.MIN,
              max: LIMIT_OF_CHARACTERS.PHONE_NUMBER.MAX,
            }),
          ]),
          type: 'phone-input',
          config: {
            enableSearch: true,
          },
        },
      ],
    },
    actions: {
      buttons: [
        {
          name: 'submit',
          htmlType: 'submit',
          render: ({}) => {
            return <CTAButton key="submit" htmlType="submit" content={t('button.make-request')} />;
          },
        },
      ],
    },
  };
};

export default getFreeConsultationFormConfig;
